import { SelectionType } from "src/js/stores/map/store";
import { createConstraintLikeClickResolver } from "../ConstraintsLayerType/constraintClickResolver/constraintClickResolver";
import { SELECTABLE_SUBSTATION_CATEGORIES } from "react-migration/domains/constraints/designation/style/StyleMap";

export const substationClickResolver = createConstraintLikeClickResolver({
  selectionType: SelectionType.SUBSTATION,
  selectableCategories: SELECTABLE_SUBSTATION_CATEGORIES,
});
